import y from "../../../../public/projects/bramha/projects/y.jpg";
import s from "../../../../public/projects/bramha/logo/s.png";
import evergreen from "../../../../public/projects/bramha/projects/ev.jpg"

// skycity
import overviewImageskycity from "../../../../public/projects/bramha/skycity/overview/1.webp";
import bannerDesktopImageskycity from "../../../../public/projects/bramha/skycity/banner/1.webp";
import bannerMobileImageskycity from "../../../../public/projects/bramha/skycity/banner/2.webp";
import Locationskycity from "../../../../public/projects/bramha/skycity/location/1.webp";
import Hightlightsskycity from "../../../../public/projects/bramha/skycity/highlights/1.webp";
import floorplan1skycity from "../../../../public/projects/bramha/skycity/floorplan/1.webp";
import floorplan2skycity from "../../../../public/projects/bramha/skycity/floorplan/2.webp";
import floorplan3skycity from "../../../../public/projects/bramha/skycity/floorplan/3.webp";
import floorplan4skycity from "../../../../public/projects/bramha/skycity/floorplan/4.webp";
import floorplan5skycity from "../../../../public/projects/bramha/skycity/floorplan/5.webp";
import locationiconskycity from "../../../../public/projects/bramha/skycity/overview/l.png";
import caliconskycity from "../../../../public/projects/bramha/skycity/overview/c.png";
import newlaunchiconskycity from "../../../../public/projects/bramha/skycity/overview/n.png";
import gallery1skycity from "../../../../public/projects/bramha/skycity/gallery/1.webp";
import gallery2skycity from "../../../../public/projects/bramha/skycity/gallery/2.webp";
import gallery3skycity from "../../../../public/projects/bramha/skycity/gallery/3.webp";
import gallery4skycity from "../../../../public/projects/bramha/skycity/gallery/4.webp";
import gallery5skycity from "../../../../public/projects/bramha/skycity/gallery/5.webp";

// projecttwo
import overviewImageprojecttwo from "../../../../public/projects/bramha/projecttwo/overview/1.webp";
import bannerDesktopImageprojecttwo from "../../../../public/projects/bramha/projecttwo/banner/1.webp";
import bannerMobileImageprojecttwo from "../../../../public/projects/bramha/projecttwo/banner/2.webp";
import Locationprojecttwo from "../../../../public/projects/bramha/projecttwo/location/1.webp";
import Hightlightsprojecttwo from "../../../../public/projects/bramha/projecttwo/highlights/1.webp";
import floorplan1projecttwo from "../../../../public/projects/bramha/projecttwo/floorplan/1.webp";
import floorplan2projecttwo from "../../../../public/projects/bramha/projecttwo/floorplan/2.webp";
import floorplan3projecttwo from "../../../../public/projects/bramha/projecttwo/floorplan/3.webp";
import floorplan4projecttwo from "../../../../public/projects/bramha/projecttwo/floorplan/4.webp";
import floorplan5projecttwo from "../../../../public/projects/bramha/projecttwo/floorplan/5.webp";
import locationiconprojecttwo from "../../../../public/projects/bramha/projecttwo/overview/l.png";
import caliconprojecttwo from "../../../../public/projects/bramha/projecttwo/overview/c.png";
import newlaunchiconprojecttwo from "../../../../public/projects/bramha/projecttwo/overview/n.png";
import gallery1projecttwo from "../../../../public/projects/bramha/projecttwo/gallery/1.webp";
import gallery2projecttwo from "../../../../public/projects/bramha/projecttwo/gallery/2.webp";
import gallery3projecttwo from "../../../../public/projects/bramha/projecttwo/gallery/3.webp";
import gallery4projecttwo from "../../../../public/projects/bramha/projecttwo/gallery/4.webp";
import gallery5projecttwo from "../../../../public/projects/bramha/projecttwo/gallery/5.webp";

// projectthree
import overviewImageprojectthree from "../../../../public/projects/bramha/projectthree/overview/1.webp";
import bannerDesktopImageprojectthree from "../../../../public/projects/bramha/projectthree/banner/1.webp";
import bannerMobileImageprojectthree from "../../../../public/projects/bramha/projectthree/banner/2.webp";
import Locationprojectthree from "../../../../public/projects/bramha/projectthree/location/1.webp";
import Hightlightsprojectthree from "../../../../public/projects/bramha/projectthree/highlights/1.webp";
import floorplan1projectthree from "../../../../public/projects/bramha/projectthree/floorplan/1.webp";
import floorplan2projectthree from "../../../../public/projects/bramha/projectthree/floorplan/2.webp";
import floorplan3projectthree from "../../../../public/projects/bramha/projectthree/floorplan/3.webp";
import floorplan4projectthree from "../../../../public/projects/bramha/projectthree/floorplan/4.webp";
import floorplan5projectthree from "../../../../public/projects/bramha/projectthree/floorplan/5.webp";
import locationiconprojectthree from "../../../../public/projects/bramha/projectthree/overview/l.png";
import caliconprojectthree from "../../../../public/projects/bramha/projectthree/overview/c.png";
import newlaunchiconprojectthree from "../../../../public/projects/bramha/projectthree/overview/n.png";
import gallery1projectthree from "../../../../public/projects/bramha/projectthree/gallery/1.webp";
import gallery2projectthree from "../../../../public/projects/bramha/projectthree/gallery/2.webp";
import gallery3projectthree from "../../../../public/projects/bramha/projectthree/gallery/3.webp";
import gallery4projectthree from "../../../../public/projects/bramha/projectthree/gallery/4.webp";
import gallery5projectthree from "../../../../public/projects/bramha/projectthree/gallery/5.webp";

// projectfour
import overviewImageprojectfour from "../../../../public/projects/bramha/projectfour/overview/1.webp";
import bannerDesktopImageprojectfour from "../../../../public/projects/bramha/projectfour/banner/1.webp";
import bannerMobileImageprojectfour from "../../../../public/projects/bramha/projectfour/banner/2.webp";
import Locationprojectfour from "../../../../public/projects/bramha/projectfour/location/1.webp";
import Hightlightsprojectfour from "../../../../public/projects/bramha/projectfour/highlights/1.webp";
import floorplan1projectfour from "../../../../public/projects/bramha/projectfour/floorplan/1.webp";
import floorplan2projectfour from "../../../../public/projects/bramha/projectfour/floorplan/2.webp";
import floorplan3projectfour from "../../../../public/projects/bramha/projectfour/floorplan/3.webp";
import floorplan4projectfour from "../../../../public/projects/bramha/projectfour/floorplan/4.webp";
import floorplan5projectfour from "../../../../public/projects/bramha/projectfour/floorplan/5.webp";
import locationiconprojectfour from "../../../../public/projects/bramha/projectfour/overview/l.png";
import caliconprojectfour from "../../../../public/projects/bramha/projectfour/overview/c.png";
import newlaunchiconprojectfour from "../../../../public/projects/bramha/projectfour/overview/n.png";
import gallery1projectfour from "../../../../public/projects/bramha/projectfour/gallery/1.webp";
import gallery2projectfour from "../../../../public/projects/bramha/projectfour/gallery/2.webp";
import gallery3projectfour from "../../../../public/projects/bramha/projectfour/gallery/3.webp";
import gallery4projectfour from "../../../../public/projects/bramha/projectfour/gallery/4.webp";
import gallery5projectfour from "../../../../public/projects/bramha/projectfour/gallery/5.webp";

// projectfive
import overviewImageprojectfive from "../../../../public/projects/bramha/projectfive/overview/1.webp";
import bannerDesktopImageprojectfive from "../../../../public/projects/bramha/projectfive/banner/1.webp";
import bannerMobileImageprojectfive from "../../../../public/projects/bramha/projectfive/banner/2.webp";
import Locationprojectfive from "../../../../public/projects/bramha/projectfive/location/1.webp";
import Hightlightsprojectfive from "../../../../public/projects/bramha/projectfive/highlights/1.webp";
import floorplan1projectfive from "../../../../public/projects/bramha/projectfive/floorplan/1.webp";
import floorplan2projectfive from "../../../../public/projects/bramha/projectfive/floorplan/2.webp";
import floorplan3projectfive from "../../../../public/projects/bramha/projectfive/floorplan/3.webp";
import floorplan4projectfive from "../../../../public/projects/bramha/projectfive/floorplan/4.webp";
import floorplan5projectfive from "../../../../public/projects/bramha/projectfive/floorplan/5.webp";
import locationiconprojectfive from "../../../../public/projects/bramha/projectfive/overview/l.png";
import caliconprojectfive from "../../../../public/projects/bramha/projectfive/overview/c.png";
import newlaunchiconprojectfive from "../../../../public/projects/bramha/projectfive/overview/n.png";
import gallery1projectfive from "../../../../public/projects/bramha/projectfive/gallery/1.webp";
import gallery2projectfive from "../../../../public/projects/bramha/projectfive/gallery/2.webp";
import gallery3projectfive from "../../../../public/projects/bramha/projectfive/gallery/3.webp";
import gallery4projectfive from "../../../../public/projects/bramha/projectfive/gallery/4.webp";
import gallery5projectfive from "../../../../public/projects/bramha/projectfive/gallery/5.webp";

// projectsix
import overviewImageprojectsix from "../../../../public/projects/bramha/projectsix/overview/1.webp";
import bannerDesktopImageprojectsix from "../../../../public/projects/bramha/projectsix/banner/1.webp";
import bannerMobileImageprojectsix from "../../../../public/projects/bramha/projectsix/banner/2.webp";
import Locationprojectsix from "../../../../public/projects/bramha/projectsix/location/1.webp";
import Hightlightsprojectsix from "../../../../public/projects/bramha/projectsix/highlights/1.webp";
import floorplan1projectsix from "../../../../public/projects/bramha/projectsix/floorplan/1.webp";
import floorplan2projectsix from "../../../../public/projects/bramha/projectsix/floorplan/2.webp";
import floorplan3projectsix from "../../../../public/projects/bramha/projectsix/floorplan/3.webp";
import floorplan4projectsix from "../../../../public/projects/bramha/projectsix/floorplan/4.webp";
import floorplan5projectsix from "../../../../public/projects/bramha/projectsix/floorplan/5.webp";
import locationiconprojectsix from "../../../../public/projects/bramha/projectsix/overview/l.png";
import caliconprojectsix from "../../../../public/projects/bramha/projectsix/overview/c.png";
import newlaunchiconprojectsix from "../../../../public/projects/bramha/projectsix/overview/n.png";
import gallery1projectsix from "../../../../public/projects/bramha/projectsix/gallery/1.webp";
import gallery2projectsix from "../../../../public/projects/bramha/projectsix/gallery/2.webp";
import gallery3projectsix from "../../../../public/projects/bramha/projectsix/gallery/3.webp";
import gallery4projectsix from "../../../../public/projects/bramha/projectsix/gallery/4.webp";
import gallery5projectsix from "../../../../public/projects/bramha/projectsix/gallery/5.webp";

// projectseven
import overviewImageprojectseven from "../../../../public/projects/bramha/projectseven/overview/1.webp";
import bannerDesktopImageprojectseven from "../../../../public/projects/bramha/projectseven/banner/1.webp";
import bannerMobileImageprojectseven from "../../../../public/projects/bramha/projectseven/banner/2.webp";
import Locationprojectseven from "../../../../public/projects/bramha/projectseven/location/1.webp";
import Hightlightsprojectseven from "../../../../public/projects/bramha/projectseven/highlights/1.webp";
import floorplan1projectseven from "../../../../public/projects/bramha/projectseven/floorplan/1.webp";
import floorplan2projectseven from "../../../../public/projects/bramha/projectseven/floorplan/2.webp";
import floorplan3projectseven from "../../../../public/projects/bramha/projectseven/floorplan/3.webp";
import floorplan4projectseven from "../../../../public/projects/bramha/projectseven/floorplan/4.webp";
import floorplan5projectseven from "../../../../public/projects/bramha/projectseven/floorplan/5.webp";
import locationiconprojectseven from "../../../../public/projects/bramha/projectseven/overview/l.png";
import caliconprojectseven from "../../../../public/projects/bramha/projectseven/overview/c.png";
import newlaunchiconprojectseven from "../../../../public/projects/bramha/projectseven/overview/n.png";
import gallery1projectseven from "../../../../public/projects/bramha/projectseven/gallery/1.webp";
import gallery2projectseven from "../../../../public/projects/bramha/projectseven/gallery/2.webp";
import gallery3projectseven from "../../../../public/projects/bramha/projectseven/gallery/3.webp";
import gallery4projectseven from "../../../../public/projects/bramha/projectseven/gallery/4.webp";
import gallery5projectseven from "../../../../public/projects/bramha/projectseven/gallery/5.webp";

// projecteight
import overviewImageprojecteight from "../../../../public/projects/bramha/projecteight/overview/1.webp";
import bannerDesktopImageprojecteight from "../../../../public/projects/bramha/projecteight/banner/1.webp";
import bannerMobileImageprojecteight from "../../../../public/projects/bramha/projecteight/banner/2.webp";
import Locationprojecteight from "../../../../public/projects/bramha/projecteight/location/1.webp";
import Hightlightsprojecteight from "../../../../public/projects/bramha/projecteight/highlights/1.webp";
import floorplan1projecteight from "../../../../public/projects/bramha/projecteight/floorplan/1.webp";
import floorplan2projecteight from "../../../../public/projects/bramha/projecteight/floorplan/2.webp";
import floorplan3projecteight from "../../../../public/projects/bramha/projecteight/floorplan/3.webp";
import floorplan4projecteight from "../../../../public/projects/bramha/projecteight/floorplan/4.webp";
import floorplan5projecteight from "../../../../public/projects/bramha/projecteight/floorplan/5.webp";
import locationiconprojecteight from "../../../../public/projects/bramha/projecteight/overview/l.png";
import caliconprojecteight from "../../../../public/projects/bramha/projecteight/overview/c.png";
import newlaunchiconprojecteight from "../../../../public/projects/bramha/projecteight/overview/n.png";
import gallery1projecteight from "../../../../public/projects/bramha/projecteight/gallery/1.webp";
import gallery2projecteight from "../../../../public/projects/bramha/projecteight/gallery/2.webp";
import gallery3projecteight from "../../../../public/projects/bramha/projecteight/gallery/3.webp";
import gallery4projecteight from "../../../../public/projects/bramha/projecteight/gallery/4.webp";
import gallery5projecteight from "../../../../public/projects/bramha/projecteight/gallery/5.webp";

// projectnine
import overviewImageprojectnine from "../../../../public/projects/bramha/projectnine/overview/1.webp";
import bannerDesktopImageprojectnine from "../../../../public/projects/bramha/projectnine/banner/1.webp";
import bannerMobileImageprojectnine from "../../../../public/projects/bramha/projectnine/banner/2.webp";
import Locationprojectnine from "../../../../public/projects/bramha/projectnine/location/1.webp";
import Hightlightsprojectnine from "../../../../public/projects/bramha/projectnine/highlights/1.webp";
import floorplan1projectnine from "../../../../public/projects/bramha/projectnine/floorplan/1.webp";
import floorplan2projectnine from "../../../../public/projects/bramha/projectnine/floorplan/2.webp";
import floorplan3projectnine from "../../../../public/projects/bramha/projectnine/floorplan/3.webp";
import floorplan4projectnine from "../../../../public/projects/bramha/projectnine/floorplan/4.webp";
import floorplan5projectnine from "../../../../public/projects/bramha/projectnine/floorplan/5.webp";
import locationiconprojectnine from "../../../../public/projects/bramha/projectnine/overview/l.png";
import caliconprojectnine from "../../../../public/projects/bramha/projectnine/overview/c.png";
import newlaunchiconprojectnine from "../../../../public/projects/bramha/projectnine/overview/n.png";
import gallery1projectnine from "../../../../public/projects/bramha/projectnine/gallery/1.webp";
import gallery2projectnine from "../../../../public/projects/bramha/projectnine/gallery/2.webp";
import gallery3projectnine from "../../../../public/projects/bramha/projectnine/gallery/3.webp";
import gallery4projectnine from "../../../../public/projects/bramha/projectnine/gallery/4.webp";
import gallery5projectnine from "../../../../public/projects/bramha/projectnine/gallery/5.webp";

// projectten
import overviewImageprojectten from "../../../../public/projects/bramha/projectten/overview/1.webp";
import bannerDesktopImageprojectten from "../../../../public/projects/bramha/projectten/banner/1.webp";
import bannerMobileImageprojectten from "../../../../public/projects/bramha/projectten/banner/2.webp";
import Locationprojectten from "../../../../public/projects/bramha/projectten/location/1.webp";
import Hightlightsprojectten from "../../../../public/projects/bramha/projectten/highlights/1.webp";
import floorplan1projectten from "../../../../public/projects/bramha/projectten/floorplan/1.webp";
import floorplan2projectten from "../../../../public/projects/bramha/projectten/floorplan/2.webp";
import floorplan3projectten from "../../../../public/projects/bramha/projectten/floorplan/3.webp";
import floorplan4projectten from "../../../../public/projects/bramha/projectten/floorplan/4.webp";
import floorplan5projectten from "../../../../public/projects/bramha/projectten/floorplan/5.webp";
import locationiconprojectten from "../../../../public/projects/bramha/projectten/overview/l.png";
import caliconprojectten from "../../../../public/projects/bramha/projectten/overview/c.png";
import newlaunchiconprojectten from "../../../../public/projects/bramha/projectten/overview/n.png";
import gallery1projectten from "../../../../public/projects/bramha/projectten/gallery/1.webp";
import gallery2projectten from "../../../../public/projects/bramha/projectten/gallery/2.webp";
import gallery3projectten from "../../../../public/projects/bramha/projectten/gallery/3.webp";
import gallery4projectten from "../../../../public/projects/bramha/projectten/gallery/4.webp";
import gallery5projectten from "../../../../public/projects/bramha/projectten/gallery/5.webp";



export const developerbramha = {
  properties: [
    {
      name: "bramha The Trillion",
      image: bannerMobileImageskycity,
      price: " 6.14 Crore Onwards",
      state: " Gurugram",
      developer: "bramha",
      location: "Sector 48, Gurugram",
      projectlocation: "Gurugram",
      bed: "3,4 BHK Apartments",
      size: "3000-3600 sq.ft.",
      url: `/bramha-trillion`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "bramha The Trillion",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "2006",
  },
  about: `bramha, a 100% FDI funded real-estate developer, backed by bramha Holdings Pte. Ltd., Singapore, the real estate investing division of the AT Holdings group of companies. AT Capital, headquartered in Singapore, was established with the aim of capitalizing on global opportunities within both established and emerging sectors.`,
};


export const projectsbramha = {

  skycity: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageskycity,
      bannerMobileImage: bannerMobileImageskycity,
      textOverlay: "",
      data: {
        title: "Bramha SkyCity",
        subtitle: "Dhanori, Pune",
        starting_price: "₹ 74 L Onwards",
        payment_plan: "",
        rerano: "P52100005193",
        status: "Under Construction"
      }
    },

    overview: {
      heading: "Bramha SkyCity",
      description: [
        "Bramha SkyCity in Dhanori, Pune, is a premium residential project by Bramha Realty & Infrastructure, offering a blend of luxury and convenience. Spread across 15 acres, the development comprises 19 towers with 11 floors each, housing 2 and 3 BHK apartments. The project is RERA registered under IDs P52100005193 and P52100029056, ensuring transparency and compliance.",
        "Residents can enjoy a plethora of amenities, including a swimming pool, gymnasium, clubhouse, children's play area, jogging track, and indoor games. The project also features 24x7 water supply, power backup, and advanced security systems, ensuring a comfortable and secure living experience.",
      ],
      keywordLinks: {
        
      },
      image: overviewImageskycity,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconskycity,
          title: "₹ 74 L Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconskycity,
          title: "2 & 3 BHK",
          subtitle: "Configurations",
        },
        {
          iconClass: newlaunchiconskycity,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "787 sq.ft.",
          price: "₹ 74.42 - 78.76 L",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "787 sq.ft.",
        price: "₹ 74.42 - 78.76 L",
        image: floorplan1skycity,
      }
    ],

    highlights: {
      images: Hightlightsskycity,
      tagline: "Highlights",
      features: [
        "Pune international airport just 2.1 km away",
        "Educational hub Viman nagar closely connected",
        "Clubhouse for artists with a steam room",
        "Project offers 40+ multi lifestyle amenities",
        "Riverview facilities are accessible",
      ],
    },

    location: {
      image: Locationskycity,
      data: [
        {
          airport: {
            distance_time: "9.4 km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "2.2 km",
            name: "Cambridge Champs International Preschool"
          },
          railwayormetro: {
            distance_time: "15.1 km",
            name: "Pune Railway Station"
          },
          hospital: {
            distance_time: "3.7 km",
            name: "Columbia Asia Hospital"
          },
          mall: {
            distance_time: "5.7 km",
            name: "Phoenix Marketcity"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1skycity },
        { image: gallery2skycity },
        { image: gallery3skycity },
        { image: gallery4skycity },
        { image: gallery5skycity },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Bramha SkyCity, kindly share more details.",
    },

    faq: [
      {
        question: "Who is the developer of Bramha SkyCity?",
        answer: "The project is developed by Bramha Realty & Infrastructure.",
      },
      {
        question: "What are the available apartment configurations?",
        answer: "Bramha SkyCity offers 2 BHK and 3 BHK apartments.",
      },
      {
        question: "Is Bramha SkyCity a gated community?",
        answer: "Yes, it is a gated community with 24/7 security and CCTV surveillance.",
      },
      {
        question: "How is the connectivity of the project?",
        answer: "Bramha SkyCity has excellent connectivity to EON IT Park, World Trade Center, and Pune Airport.",
      },
      {
        question: "Is the project suitable for families?",
        answer: "Yes, Bramha SkyCity is ideal for families due to its peaceful environment and spacious homes.",
      },
      {
        question: "Does the project offer parking space?",
        answer: "Yes, each apartment comes with dedicated covered parking for residents and visitor parking as well.",
      },
      {
        question: "What is the possession status?",
        answer: "The project is under construction.",
      },
      {
        question: "What are the nearby landmarks and facilities?",
        answer: "Bramha SkyCity is close to educational institutions like Proxima International School, healthcare facilities such as Sahyadri Super Speciality Hospital.",
      },
      {
        question: "Are there eco-friendly features in the project?",
        answer: "Yes, the project includes features like rainwater harvesting, energy-efficient lighting."
      },
      {
        question: "What is the price range for apartments at Bramha SkyCity?",
        answer: "Prices start from ₹74.42 Lakhs onwards for 2 BHK apartments."
      },
      
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecttwo: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecttwo,
      bannerMobileImage: bannerMobileImageprojecttwo,
      textOverlay: "",
      data: {
        title: "bramha The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "bramha The Trillion",
      description: [
        "bramha The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by bramha Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at bramha Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at bramha Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of bramha The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "bramha": "/developers/bramha",
      },
      image: overviewImageprojecttwo,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecttwo,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecttwo,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecttwo,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecttwo,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecttwo,
      }
    ],

    highlights: {
      images: Hightlightsprojecttwo,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecttwo,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecttwo },
        { image: gallery2projecttwo },
        { image: gallery3projecttwo },
        { image: gallery4projecttwo },
        { image: gallery5projecttwo },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in bramha The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is bramha The Trillion located?",
        answer: `bramha The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at bramha The Trillion?",
        answer: `bramha The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in bramha The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at bramha The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, bramha The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of bramha The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at bramha The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of bramha The Trillion?",
        answer: `bramha The Trillion is developed by bramha Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is bramha The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, bramha The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from bramha The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectthree: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectthree,
      bannerMobileImage: bannerMobileImageprojectthree,
      textOverlay: "",
      data: {
        title: "bramha The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "bramha The Trillion",
      description: [
        "bramha The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by bramha Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at bramha Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at bramha Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of bramha The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "bramha": "/developers/bramha",
      },
      image: overviewImageprojectthree,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectthree,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectthree,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectthree,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectthree,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectthree,
      }
    ],

    highlights: {
      images: Hightlightsprojectthree,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectthree,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectthree },
        { image: gallery2projectthree },
        { image: gallery3projectthree },
        { image: gallery4projectthree },
        { image: gallery5projectthree },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in bramha The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is bramha The Trillion located?",
        answer: `bramha The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at bramha The Trillion?",
        answer: `bramha The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in bramha The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at bramha The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, bramha The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of bramha The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at bramha The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of bramha The Trillion?",
        answer: `bramha The Trillion is developed by bramha Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is bramha The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, bramha The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from bramha The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfour: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfour,
      bannerMobileImage: bannerMobileImageprojectfour,
      textOverlay: "",
      data: {
        title: "bramha The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "bramha The Trillion",
      description: [
        "bramha The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by bramha Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at bramha Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at bramha Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of bramha The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "bramha": "/developers/bramha",
      },
      image: overviewImageprojectfour,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfour,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfour,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfour,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfour,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfour,
      }
    ],

    highlights: {
      images: Hightlightsprojectfour,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfour,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfour },
        { image: gallery2projectfour },
        { image: gallery3projectfour },
        { image: gallery4projectfour },
        { image: gallery5projectfour },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in bramha The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is bramha The Trillion located?",
        answer: `bramha The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at bramha The Trillion?",
        answer: `bramha The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in bramha The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at bramha The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, bramha The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of bramha The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at bramha The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of bramha The Trillion?",
        answer: `bramha The Trillion is developed by bramha Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is bramha The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, bramha The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from bramha The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfive: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfive,
      bannerMobileImage: bannerMobileImageprojectfive,
      textOverlay: "",
      data: {
        title: "bramha The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "bramha The Trillion",
      description: [
        "bramha The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by bramha Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at bramha Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at bramha Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of bramha The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "bramha": "/developers/bramha",
      },
      image: overviewImageprojectfive,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfive,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfive,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfive,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfive,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfive,
      }
    ],

    highlights: {
      images: Hightlightsprojectfive,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfive,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfive },
        { image: gallery2projectfive },
        { image: gallery3projectfive },
        { image: gallery4projectfive },
        { image: gallery5projectfive },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in bramha The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is bramha The Trillion located?",
        answer: `bramha The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at bramha The Trillion?",
        answer: `bramha The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in bramha The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at bramha The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, bramha The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of bramha The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at bramha The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of bramha The Trillion?",
        answer: `bramha The Trillion is developed by bramha Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is bramha The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, bramha The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from bramha The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectsix: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectsix,
      bannerMobileImage: bannerMobileImageprojectsix,
      textOverlay: "",
      data: {
        title: "bramha The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "bramha The Trillion",
      description: [
        "bramha The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by bramha Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at bramha Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at bramha Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of bramha The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "bramha": "/developers/bramha",
      },
      image: overviewImageprojectsix,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectsix,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectsix,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectsix,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectsix,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectsix,
      }
    ],

    highlights: {
      images: Hightlightsprojectsix,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectsix,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectsix },
        { image: gallery2projectsix },
        { image: gallery3projectsix },
        { image: gallery4projectsix },
        { image: gallery5projectsix },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in bramha The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is bramha The Trillion located?",
        answer: `bramha The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at bramha The Trillion?",
        answer: `bramha The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in bramha The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at bramha The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, bramha The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of bramha The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at bramha The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of bramha The Trillion?",
        answer: `bramha The Trillion is developed by bramha Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is bramha The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, bramha The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from bramha The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectseven: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectseven,
      bannerMobileImage: bannerMobileImageprojectseven,
      textOverlay: "",
      data: {
        title: "bramha The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "bramha The Trillion",
      description: [
        "bramha The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by bramha Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at bramha Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at bramha Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of bramha The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "bramha": "/developers/bramha",
      },
      image: overviewImageprojectseven,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectseven,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectseven,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectseven,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectseven,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectseven,
      }
    ],

    highlights: {
      images: Hightlightsprojectseven,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectseven,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectseven },
        { image: gallery2projectseven },
        { image: gallery3projectseven },
        { image: gallery4projectseven },
        { image: gallery5projectseven },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in bramha The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is bramha The Trillion located?",
        answer: `bramha The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at bramha The Trillion?",
        answer: `bramha The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in bramha The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at bramha The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, bramha The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of bramha The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at bramha The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of bramha The Trillion?",
        answer: `bramha The Trillion is developed by bramha Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is bramha The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, bramha The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from bramha The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecteight: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecteight,
      bannerMobileImage: bannerMobileImageprojecteight,
      textOverlay: "",
      data: {
        title: "bramha The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "bramha The Trillion",
      description: [
        "bramha The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by bramha Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at bramha Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at bramha Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of bramha The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "bramha": "/developers/bramha",
      },
      image: overviewImageprojecteight,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecteight,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecteight,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecteight,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecteight,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecteight,
      }
    ],

    highlights: {
      images: Hightlightsprojecteight,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecteight,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecteight },
        { image: gallery2projecteight },
        { image: gallery3projecteight },
        { image: gallery4projecteight },
        { image: gallery5projecteight },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in bramha The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is bramha The Trillion located?",
        answer: `bramha The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at bramha The Trillion?",
        answer: `bramha The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in bramha The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at bramha The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, bramha The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of bramha The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at bramha The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of bramha The Trillion?",
        answer: `bramha The Trillion is developed by bramha Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is bramha The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, bramha The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from bramha The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectnine: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectnine,
      bannerMobileImage: bannerMobileImageprojectnine,
      textOverlay: "",
      data: {
        title: "bramha The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "bramha The Trillion",
      description: [
        "bramha The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by bramha Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at bramha Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at bramha Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of bramha The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "bramha": "/developers/bramha",
      },
      image: overviewImageprojectnine,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectnine,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectnine,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectnine,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectnine,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectnine,
      }
    ],

    highlights: {
      images: Hightlightsprojectnine,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectnine,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectnine },
        { image: gallery2projectnine },
        { image: gallery3projectnine },
        { image: gallery4projectnine },
        { image: gallery5projectnine },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in bramha The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is bramha The Trillion located?",
        answer: `bramha The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at bramha The Trillion?",
        answer: `bramha The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in bramha The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at bramha The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, bramha The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of bramha The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at bramha The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of bramha The Trillion?",
        answer: `bramha The Trillion is developed by bramha Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is bramha The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, bramha The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from bramha The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectten: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectten,
      bannerMobileImage: bannerMobileImageprojectten,
      textOverlay: "",
      data: {
        title: "bramha The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "bramha The Trillion",
      description: [
        "bramha The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by bramha Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at bramha Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at bramha Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of bramha The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "bramha": "/developers/bramha",
      },
      image: overviewImageprojectten,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectten,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectten,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectten,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectten,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectten,
      }
    ],

    highlights: {
      images: Hightlightsprojectten,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectten,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectten },
        { image: gallery2projectten },
        { image: gallery3projectten },
        { image: gallery4projectten },
        { image: gallery5projectten },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in bramha The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is bramha The Trillion located?",
        answer: `bramha The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at bramha The Trillion?",
        answer: `bramha The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in bramha The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at bramha The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, bramha The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of bramha The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at bramha The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of bramha The Trillion?",
        answer: `bramha The Trillion is developed by bramha Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is bramha The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, bramha The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from bramha The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
